import React, { useState } from "react";
import {
  Box,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as Yup from "yup";
import { ForgotPassword } from "../services/LoginUser";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";

import TopVector from "../assets/images/topVector.png";
import BottomVector from "../assets/images/bottomVector.png";
import "../css/forgotpassword.css";

const ForgetPassword = ({ setOpenForgetPwdDialog }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleLogin = async (values, { resetForm }) => {
    if (loading) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("email", values.email);

      const response = await ForgotPassword(formData);
      if (response) {
        localStorage.setItem("email", values.email);
        setTimeout(() => setOpenForgetPwdDialog(false), 2500);
      }
      resetForm();
    } catch (e) {
      resetForm();
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(t("ForgetPassword.PleaseEnterEmail"))
        .required(t("ForgetPassword.PleaseEnterEmail")),
    }),
    onSubmit: handleLogin,
  });

  return (
    <Box className="forget-modal-card">
      {/* Decorative vectors */}
      <img src={TopVector} alt="" className="vector top-vector" />
      <img src={BottomVector} alt="" className="vector bottom-vector" />

      {/* Close button */}
      <Box
        className="forget-close-btn"
        onClick={() => setOpenForgetPwdDialog(false)}
      >
        <CloseIcon />
      </Box>
      <Box className="form-container">
        <form onSubmit={formik.handleSubmit} noValidate>
          <label className="form-label">Email</label>
          <TextField
            fullWidth
            // sx={{width:"70%"}}
            // label={t("ForgetPassword.Email")}
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
          />

          <Box className="btn-wrapper">
            <Button
              type="submit"
              fullWidth
              disabled={loading}
              className="continue-btn"
            >
              {t("ForgetPassword.Continue")}
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default ForgetPassword;
